import React from 'react';

export default function CleaningRecordsPage() {
  return (
    <div>
      <h2>Cleaning Records</h2>
      <p>This is where you’ll see all hull‐cleaning reports and history.</p>
    </div>
  );
}
